import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { FaTrashAlt } from 'react-icons/fa';
import _ from 'lodash';
import { useMutation } from '@apollo/client';
import { DELETE_USER_CONFIRM } from '../../../../graphql/userConfirm/userAddress/mutation';
import { errorFields, successFields } from '../../../../helpers/sweetalert';
import { convertLogicticsName, formatDeliveryAddress } from '../../../../helpers';
import '../../../orders/OrderConfirm/checkout-theme.css';

const DeleteReceiveAddress = ({ userAddress, onClose, setDeleteReceiveModal }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const [deleteUserAddress_API] = useMutation(DELETE_USER_CONFIRM);
    const confirmDelete = async () => {
        // ກັນກົດຊ້ຳ — ຍິງ 2 ເທື່ອຈະໄດ້ error ຮອບທີ 2 ທັງທີ່ລຶບສຳເລັດແລ້ວ
        if (isDeleting) return;
        try {
            setIsDeleting(true);
            const response = await deleteUserAddress_API({
                variables: {
                    where: {
                        id: userAddress?.value?.id,
                        user: userAddress?.value?.user
                    }
                }
            });
            if (response?.data?.delUserAddress?.message === "Success") {
                onClose();
                successFields({ text: "ລຶບທີ່ຢູ່ຂົນສົ່ງສຳເລັດ" });
            }
        } catch (error) {
            console.log(error);
            onClose();
            errorFields({ text: "ລຶບທີ່ຢູ່ບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່" });
        } finally {
            setIsDeleting(false);
        }
    };

    if (_.isEmpty(userAddress)) {
        return <div className="cf-dialog__body">ກຳລັງໂຫຼດ...</div>;
    }

    const _address = userAddress?.value;

    return (
        <div className="cf-dialog__body">
            <span className="cf-dialog__icon" aria-hidden="true">
                <FaTrashAlt />
            </span>

            <div className="cf-dialog__title">ລົບທີ່ຢູ່ນີ້ອອກບໍ?</div>

            {/* ບອກໃຫ້ຊັດວ່າກຳລັງລຶບອັນໃດ — ບໍ່ດັ່ງນັ້ນລູກຄ້າທີ່ມີຫຼາຍທີ່ຢູ່ຈະລຶບຜິດອັນ */}
            <div className="cf-addr" style={{ textAlign: 'left' }}>
                {_address?.img && (
                    <img className="cf-addr__logo" src={_address?.img} alt="" />
                )}
                <span className="cf-addr__text">
                    <span className="cf-addr__name">
                        {convertLogicticsName(_address?.deliveryName)}
                    </span>
                    <span className="cf-addr__meta">
                        {_address?.userName} · {_address?.userTel}
                    </span>
                    <span className="cf-addr__meta">{formatDeliveryAddress(_address)}</span>
                </span>
            </div>

            <div className="cf-dialog__text">ລົບແລ້ວເອົາຄືນບໍ່ໄດ້</div>

            <div className="cf-actions">
                <button
                    type="button"
                    className="cf-btn cf-btn--danger"
                    onClick={confirmDelete}
                    disabled={isDeleting}
                >
                    {isDeleting && <Spinner size="sm" animation="border" />}
                    ລົບທີ່ຢູ່
                </button>
                <button
                    type="button"
                    className="cf-btn cf-btn--secondary"
                    onClick={() => setDeleteReceiveModal(false)}
                    disabled={isDeleting}
                >
                    ຍົກເລີກ
                </button>
            </div>
        </div>
    );
};

export default DeleteReceiveAddress;
